import { ComponentProps } from 'react';
import { Row } from 'antd';
import clsx from 'clsx';

interface IOpRowProps extends ComponentProps<typeof Row> {
  testId?: string;
}

export const OpRow = ({
  className,
  testId = 'op-row',
  ...rowProps
}: IOpRowProps) => {
  return (
    <Row
      className={clsx('op-row', className)}
      data-testid={testId}
      {...rowProps}
    />
  );
};
